import { render, staticRenderFns } from "./CustomExportWrap.vue?vue&type=template&id=367ae2b2&scoped=true&"
import script from "./CustomExportWrap.vue?vue&type=script&lang=ts&"
export * from "./CustomExportWrap.vue?vue&type=script&lang=ts&"
import style0 from "./CustomExportWrap.vue?vue&type=style&index=0&id=367ae2b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ae2b2",
  null
  
)

export default component.exports